import type { AnnualRate, RiskProfile } from './constants';

import { ObjectUtils } from '@polyseme/utils/typescript/typescript-utils';

import { ANNUAL_RATES } from './constants';

export const getRiskProfileByRates = (
  rate: AnnualRate
): RiskProfile | undefined =>
  ObjectUtils.keys(ANNUAL_RATES).find((profile) => {
    const rates = ANNUAL_RATES[profile];
    return (
      rates.min === rate.min &&
      rates.median === rate.median &&
      rates.max === rate.max
    );
  });
